module.exports = __webpack_public_path__ + "media/2-6.2b2904f8.wav";